import { useHistory } from "react-router";

import BrandsManagementPage from "pages/admin/brands/Brands";
import PageWrapper from "components/PageWrapper";

export default function BrandsRoute() {
  const history = useHistory();
  return (
    <PageWrapper
      label="Brands"
      navigationHandler={{ handleBack: () => history.push("/") }}
    >
      <BrandsManagementPage />
    </PageWrapper>
  );
}
